<template>
  <div class="image-upload" :class="{ multiple: limit > 1 }">
    <div v-for="(url, index) in fileList" :key="url + '-' + index" class="preview-item">
      <el-image :src="url" fit="cover" :preview-src-list="fileList" />
      <span v-if="!disabled" class="remove" @click="remove(index)"><i class="el-icon-close" /></span>
    </div>
    <el-upload
      v-if="!disabled && fileList.length < limit"
      class="uploader"
      :action="action"
      :headers="headers"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-success="onSuccess"
      :on-error="onError"
      name="file"
      :accept="accept"
    >
      <div class="upload-trigger">
        <i class="el-icon-plus" />
        <span>{{ tip || '上传图片' }}</span>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import { mediaUrl } from '@/utils/media'

export default {
  name: 'ImageUpload',
  props: {
    value: { type: [String, Array], default: '' },
    limit: { type: Number, default: 1 },
    tip: { type: String, default: '' },
    action: { type: String, default: '/storeapi/upload/image' },
    maxSizeMb: { type: Number, default: 50 },
    accept: { type: String, default: 'image/*' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    headers() {
      const token = getToken()
      return token ? { Authorization: 'Bearer ' + token } : {}
    },
    fileList() {
      const raw = Array.isArray(this.value)
        ? this.value.filter(Boolean)
        : (this.value ? [String(this.value)] : [])
      return raw.map(mediaUrl).filter(Boolean)
    }
  },
  methods: {
    emitValue(list) {
      if (this.limit <= 1) {
        this.$emit('input', list[0] || '')
      } else {
        this.$emit('input', list)
      }
      this.$emit('change', this.limit <= 1 ? (list[0] || '') : list)
    },
    beforeUpload(file) {
      const isVideo = /^video\//.test(file.type)
      const isImage = /^image\//.test(file.type)
      const allowVideo = this.accept.indexOf('video') >= 0
      if (!isImage && !(allowVideo && isVideo)) {
        this.$message.error(allowVideo ? '只能上传图片或视频' : '只能上传图片文件')
        return false
      }
      const limit = isVideo ? Math.max(this.maxSizeMb, 50) : Math.min(this.maxSizeMb, 5)
      const okSize = file.size / 1024 / 1024 < limit
      if (!okSize) {
        this.$message.error(`文件大小不能超过 ${limit}MB`)
        return false
      }
      return true
    },
    onSuccess(res) {
      if (!res || res.code !== 1) {
        this.$message.error((res && res.msg) || '上传失败')
        return
      }
      const url = mediaUrl((res.data && (res.data.url || res.data.full_url || res.data.path)) || '')
      if (!url) {
        this.$message.error('上传成功但未返回地址')
        return
      }
      const list = this.fileList.slice()
      list.push(url)
      this.emitValue(list.slice(0, this.limit))
      this.$message.success('上传成功')
    },
    onError() {
      this.$message.error('上传失败')
    },
    remove(index) {
      const list = this.fileList.slice()
      list.splice(index, 1)
      this.emitValue(list)
    }
  }
}
</script>

<style lang="scss" scoped>
.image-upload {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.preview-item {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #d7ebe3;
  .el-image {
    width: 100%;
    height: 100%;
  }
  ::v-deep .el-image__inner {
    width: 100%;
    height: 100%;
  }
  .remove {
    position: absolute;
    top: 0;
    right: 0;
    width: 22px;
    height: 22px;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-bottom-left-radius: 8px;
  }
}
.uploader {
  ::v-deep .el-upload {
    border: 1px dashed #b7d5cb;
    border-radius: 8px;
    cursor: pointer;
    background: #f4faf7;
    &:hover {
      border-color: #0f8a6a;
      color: #0f8a6a;
    }
  }
}
.upload-trigger {
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #7a8f87;
  i {
    font-size: 22px;
    margin-bottom: 6px;
  }
  span {
    font-size: 12px;
  }
}
</style>
